var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inline)?_c('div',{ref:"edited",class:_vm.classes,attrs:{"contenteditable":"true","id":_vm.editorId}}):_c('textarea',{ref:"edited",class:_vm.classes,attrs:{"name":_vm.editorId}})
}
var staticRenderFns = []

export { render, staticRenderFns }